export const getStyling = {
  space: (space) => (props) => props?.theme?.space[space],
};
